<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faSparkle"></vx-wallpaper>
        <div class="relative p-6 max-w-2xl xl:p-10">
            <h2 class="mb-2 text-xl font-bold">Overview</h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                Agents review every marketing or transactional message before they are sent. Create agents that check
                tone, accuracy, and formatting using your brand rules. Add agents to your brand standards to ensure
                quality at scale.
            </p>
            <a
                href="https://explore.voxie.com/voxiesupport/brand-standards"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-sans font-normal text-sky-500 underline lg:text-base"
            >
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2" :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup lang="ts">
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong, faSparkle } from '@fortawesome/pro-solid-svg-icons';
</script>
